import { productCodesFilterAtom } from 'atoms/filters/sim-products';
import { productCodesHintsAtom } from 'atoms/hints/sim-products';
import { ProductCodeSearchFilter } from 'src/common/components/Filters/Inputs/productCode/ProductCodeSearchFilter';

export const ProductCodesSearchInput = () => {
  return (
    <ProductCodeSearchFilter
      productCodesFilterAtom={productCodesFilterAtom}
      productCodesHintsAtom={productCodesHintsAtom}
    />
  );
};
